<template>
  <v-dialog v-model="dialog" fullscreen hide-overlay transition="dialog-bottom-transition">

    <v-card v-if="loadingScreenShot" class="mb-12" flat>
      <v-row>
        <v-col cols="6">
          <v-skeleton-loader
            class="ml-2 my-2"
            type="image"
          ></v-skeleton-loader>
        </v-col>
        <v-col cols="6">
          <v-skeleton-loader
            class="ml-2 my-2"
            type="card"
          ></v-skeleton-loader>
        </v-col>
      </v-row>
    </v-card>

    <v-card v-if="option && !loadingScreenShot" class="mb-12" flat>
      <v-row>
        <v-col cols="12">
          <OptionReviewCard :option="option" :imgUrl="option.imgSrc" :criteria="criteriaList" :criteriaValueOptions="criteriaValueOptions" :previousCriteriaValues="criteriaValues" :screenGrabId="screenGrabId" :screenShotReady.sync="screenShotReady" @onSelectValue="selectSourceValue">
            <template v-slot:leftActions v-if="foundDifferences">
              <v-btn text @click="cancelChanges()">Cancel</v-btn>
            </template>
            <template v-slot:rightActions>
              <v-btn
                color="success"
                :loading="saving"
                @click="saveOptionCriteriaValues"
              >
                {{ foundDifferences ? 'Save' : 'Done' }}
              </v-btn>
            </template>
          </OptionReviewCard>
        </v-col>
      </v-row>
    </v-card>
  </v-dialog>
</template>

<script>
// TODO rename this to review rescrape dialog
// The rescraping is alrady done when checkig values, this is just the UI to review that.

// import CriteriaValue from '@/components/CriteriaValue.vue'
import Constants from '../constants.json'
// This import loads the firebase namespace along with all its type information.
import * as firebase from 'firebase/app'
// Load the auth feature into the firebase namespace.
import 'firebase/auth'
import axios from 'axios'

import { mapGetters } from 'vuex'
// Veux types
import * as DecisionTypes from '../store/types/decision'

import OptionReviewCard from '@/components/OptionReviewCard.vue'

export default {
  name: 'RescrapeCriteriaDialog',
  components: {
    OptionReviewCard
  },
  props: {
    value: Boolean,
    option: Object,
    scrapeResult: Object,
    // decisionCriteria: Object
  },
  data () {
    return {
      editingValues: null,
      // originalValues: null,
      newSha256: null,
      screenGrabId: null,
      screenShotReady: false,
      loadingScreenShot: false,
      criteriaValueOptions: {},
      foundDifferences: false,
      saving: false
    }
  },
  computed: {
    ...mapGetters('decision',{
      criteriaList: 'criteriaList'
    }),
    dialog: {
      // getter
      get: function () {
        return this.value
      },
      // setter
      set: function (newValue) {
        this.$emit('input', newValue)
      }
    },
    optionName () {
      return this.option ? this.option.name : ''
    },
    criteriaValues () {
      let res = {...this.option.criteriaValues}
      this.criteriaList.forEach((item) => {
        if (!this.option.criteriaValues[item.id]) {
          res[item.id] = {userValue: null, sourceValue: null}
        }
      })

      return res
    }
    // criteriaList () {
    //     let res = []
    //     if (this.decisionCriteria) {
    //       res = Object.keys(this.decisionCriteria).map( (key) => {
    //           const criteriaItem = { ...this.decisionCriteria[key] }
    //           criteriaItem.id = key
    //           return criteriaItem
    //       })
    //     }
    //     res.sort((a, b) => a.order - b.order)
    //     //res.sort((a, b) => a.name.localeCompare(b.name))
    //     return res
    // }
  },
  mounted: function () {
    this.initDialog()
  },
  watch: {
    // whenever question changes, this function will run
    value: function (newValue) {
      if (newValue === true) {
        this.initDialog()
      } else {
        this.criteriaValueOptions = {}
        this.screenGrabId = null
      }
    }
  },
  methods: {
    initDialog: function() {
      if (this.option) {
        this.editingValues = JSON.parse(JSON.stringify(this.criteriaValues))
        // this.originalValues = JSON.parse(JSON.stringify(this.option.criteriaValues))
        this.newSha256 = null
        this.screenShotReady = false
        this.initData()
      }
    },
    cancelChanges: function () {
      // this.option.criteriaValues = JSON.parse(JSON.stringify(this.originalValues))
      this.dialog = false
    },
    selectSourceValue: function (criteriaId, criteriaValue, valueIndex) {
      this.editingValues[criteriaId].sourceValue = criteriaValue.value
      this.editingValues[criteriaId].selectorId = criteriaValue.selectorId
      this.editingValues[criteriaId].selectorKey = criteriaValue.selectorKey
      this.editingValues[criteriaId].sourceIndex = valueIndex
      this.editingValues[criteriaId].keyword = criteriaValue.keyword
      this.editingValues[criteriaId].filteredKeywordFromValue = criteriaValue.filteredKeywordFromValue
      this.editingValues[criteriaId].domSelector = criteriaValue.domSelector
      this.editingValues[criteriaId].pagePosition = criteriaValue.pagePosition
    },
    saveOptionCriteriaValues: async function () {
      const token = firebase.auth().currentUser && (await firebase.auth().currentUser.getIdToken())
      this.saving = true

      if (this.option.sha256 !== this.newSha256) {
        const postNewSha256URL = `${Constants.API_BASE_PATH}/decisions/${this.option.decisionId}/options/${this.option.id}/sha256`
        const postSha256Body = {sha256: this.newSha256}
        // console.log(`Calling option post sha256 ${JSON.stringify(postSha256Body)}`)
        await axios.post(postNewSha256URL, postSha256Body, {
          headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${token}`,
          }
        })

        // this.option.sha256 = this.newSha256
        this.$store.commit(`decision/${DecisionTypes.MUTATION_OPTION_HASH}`, {id: this.option.id, sha256: this.newSha256})
      }

      if (this.foundDifferences) {
        // TODO save changes
        const postCriteriaValuesURL = `${Constants.API_BASE_PATH}/decisions/${this.option.decisionId}/options/${this.option.id}/criteria`
        const postValuesBody = {criteriaValues: this.editingValues, removeValueOptions: true}
        await axios.post(postCriteriaValuesURL, postValuesBody, {
          headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${token}`,
          }
        })

        // Commit the changes
        this.$store.commit(`decision/${DecisionTypes.MUTATION_OPTION_CRITERIA_VALUES}`, {id: this.option.id, criteriaValues: JSON.parse(JSON.stringify(this.editingValues))})
      }

      this.saving = false
      this.dialog = false
    },
    initData: async function () {
      if (this.option.url) {
        // First clear on selected values and re-sync criteria. They might have changed and this could be the second build (if back button was used)
        this.screenGrabId = null
        const token = firebase.auth().currentUser && (await firebase.auth().currentUser.getIdToken())
        const getScreenshotURL = `${Constants.API_BASE_PATH}/screenshot/latest`
        const screenshotBody = {
          url: this.option.url,
          sha256: this.scrapeResult.sha256
        }
        const criteriaIds = Object.keys(this.editingValues)

        this.loadingScreenShot = true
        this.foundDifferences = false
        const self = this
        axios.post(getScreenshotURL, screenshotBody, {
          headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${token}`,
          }
        }).then(function (res) {
          //if (res && res.status === 200 && res.data && res.data.scrapeResult && res.data.scrapeResult.status !== 'failed') {
          if (res && res.status === 200 && res.data && res.data.status === 'success') {
            self.screenGrabId = res.data.screenGrabId
            //self.newSha256 = res.data.scrapeResult.sha256
            self.newSha256 = self.scrapeResult.sha256

            // Add possible criteria values for those that have new values
            self.criteriaValueOptions = {}
            criteriaIds.forEach((criteriaId) => {
              // self.criteriaValueOptions[criteriaId] = res.data.scrapeResult.newValues[criteriaId] || null
              self.criteriaValueOptions[criteriaId] = self.scrapeResult.newValues[criteriaId] || null
              // Set the value to the first in the list
              if (self.criteriaValueOptions[criteriaId] && self.criteriaValueOptions[criteriaId].length > 0) {
                self.foundDifferences = true
                self.editingValues[criteriaId].sourceValue = self.criteriaValueOptions[criteriaId][0].value
                self.editingValues[criteriaId].sourceIndex = 0
                self.editingValues[criteriaId].selectorId = self.criteriaValueOptions[criteriaId][0].selectorId
                self.editingValues[criteriaId].selectorKey = self.criteriaValueOptions[criteriaId][0].selectorKey
                self.editingValues[criteriaId].keyword = self.criteriaValueOptions[criteriaId][0].keyword
                self.editingValues[criteriaId].filteredKeywordFromValue = self.criteriaValueOptions[criteriaId][0].filteredKeywordFromValue
                self.editingValues[criteriaId].domSelector = self.criteriaValueOptions[criteriaId][0].domSelector
                self.editingValues[criteriaId].pagePosition = self.criteriaValueOptions[criteriaId][0].pagePosition
              }
            })

          }
          // else {
          //   console.log(`Unexpected response ${JSON.stringify(res)}`)
          //   alert('Unexpected response creating new option')
          // }

          // Indicate loading is over
          self.loadingScreenShot = false
        })
        .catch(function (/*error*/) {
          // console.log(error);
        })
      }
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
.review-container {
  position: relative;
}
.v-card__title {
  font-size: 1rem;
  position: relative;
  background-color: rgba(0,0,0,0.6);
  padding: 5px 16px;
}

</style>
